import { render } from "./EventExhibitions.vue?vue&type=template&id=7796feb0&scoped=true"
import script from "./EventExhibitions.vue?vue&type=script&lang=js"
export * from "./EventExhibitions.vue?vue&type=script&lang=js"

import "./EventExhibitions.vue?vue&type=style&index=0&id=7796feb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7796feb0"]])

export default __exports__